import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { mapOfferDurationToMonths } from '../../mapOfferDurationToMonths';

export const mapOfferDurationToProduct = (
    offer: NonNullable<
        NonNullable<GetFormalOffersResponse['data']>['formal_offers']
    >[number]
) => {
    const duration = mapOfferDurationToMonths(offer);

    switch (duration) {
        case 3:
            return 'THREE_MONTHS';
        case 12:
            return 'TWELVE_MONTHS';
        default:
            return null;
    }
};
